import { getObjectAttribute } from "./estree.js";
export function sectionToAttribute(root) {
    const children = getSectionContainers(root, "");
    const serializableTree = getSerializableNode(root, "");
    return {
        children,
        attributes: [
            {
                type: "mdxJsxAttribute",
                name: "__hike",
                value: getObjectAttribute(serializableTree),
            },
        ],
    };
}
function getSerializableNode(section, path) {
    const newPath = path ? [path, section.name].join(".") : section.name;
    const node = {
        children: newPath,
        title: section.title,
        _data: section._data,
    };
    section.children.forEach((child) => {
        if (child.type === "content") {
            return;
        }
        if (child.type === "section") {
            const childNode = getSerializableNode(child, newPath);
            if (child.multi) {
                node[child.name] = node[child.name] || [];
                node[child.name].push(childNode);
            }
            else {
                node[child.name] = childNode;
            }
            return;
        }
        let { name, index, multi, type, ...childNode } = child;
        if (child.type === "quote") {
            childNode = child.value;
        }
        if (multi) {
            node[name] = node[name] || [];
            node[name].push(childNode);
        }
        else {
            node[name] = childNode;
        }
    });
    return node;
}
function getSectionContainers(section, path) {
    const newPath = path ? [path, section.name].join(".") : section.name;
    const children = [sectionContainer(section, newPath)];
    section.children
        .filter((child) => child.type === "section")
        .forEach((child) => {
        children.push(...getSectionContainers(child, newPath));
    });
    return children;
}
function sectionContainer(section, path) {
    return {
        type: "mdxJsxFlowElement",
        name: "slot",
        attributes: [
            {
                type: "mdxJsxAttribute",
                name: "path",
                value: path,
            },
        ],
        children: sectionChildren(section),
    };
}
function sectionChildren(section) {
    const elements = section.children
        .map((child) => {
        if (child.type === "content") {
            return child.value;
        }
        if (child.type === "section") {
            return placeholder(child);
        }
    })
        .filter((x) => !!x);
    const child = elements.length == 1
        ? elements[0]
        : {
            // wrap elemts in fragment
            type: "mdxJsxFlowElement",
            name: null,
            attributes: [],
            children: elements,
        };
    return child ? [child] : [];
}
function placeholder(node) {
    const { name, index } = node;
    const startsWithLowercase = name && name.charAt(0) === name.charAt(0).toLowerCase();
    if (startsWithLowercase) {
        return null;
    }
    const attributes = [
        {
            type: "mdxJsxAttribute",
            name: "title",
            value: node.title,
        },
    ];
    if (index != null) {
        attributes.push({
            type: "mdxJsxAttribute",
            name: "index",
            value: {
                type: "mdxJsxAttributeValueExpression",
                value: index.toString(),
                data: {
                    estree: {
                        type: "Program",
                        body: [
                            {
                                type: "ExpressionStatement",
                                expression: {
                                    type: "Literal",
                                    value: index,
                                    raw: index.toString(),
                                },
                            },
                        ],
                        sourceType: "module",
                        comments: [],
                    },
                },
            },
        });
    }
    return {
        type: "mdxJsxFlowElement",
        name: name,
        attributes,
        children: sectionChildren(node),
    };
}
